import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MyProfile } from '../models/myProfile';
import { Observable } from 'rxjs';
import { MyProfileView } from '../models/myProfileView';
import { NewPassword } from '../models/newPassword';
import { AppInitService } from 'src/app/app-init.service';
import { DomSanitizer } from '@angular/platform-browser';
import { AppConfigurations } from 'src/app/shared/models/appConfiguration.model';

@Injectable({
  providedIn: 'root'
})
export class MasterMyProfileService {

  myProfileUri = '';
  userId?: string;
  appConfig?: AppConfigurations;

  constructor(private httpClient: HttpClient, 
    private appInitService: AppInitService, public sanitizer: DomSanitizer) {
      appInitService.getAppConfiguration$().subscribe({
        next: (config) => this._onRecieveAppConfig(config)
      })
    }
    
  private _onRecieveAppConfig(appConfig: AppConfigurations){
    this.appConfig = appConfig;
    this.myProfileUri = `${this.appConfig.adminApi.baseApiUrl}${this.appConfig.adminApi.userController}`;
  }

  getUserFullName(): Observable<string> {
    const profileNameUrl = `${this.myProfileUri}${'fullName'}`;
    return this.httpClient.get<string>(profileNameUrl);
  }

  getLoggedUserProfile(): Observable<MyProfileView> {
      const profileDetailsUrl = `${this.myProfileUri}${'loggeduser'}`;
      return this.httpClient.get<MyProfileView>(profileDetailsUrl);
  }

  saveLoggedUserProfile(data: MyProfile): Observable<any> {
    const saveLoggedUserUrl = `${this.myProfileUri}${'loggeduser'}`;
    return this.httpClient.put<MyProfile>(saveLoggedUserUrl, data);
    
  }

  updatePassword(passwordData: NewPassword): Observable<any> {
    const saveLoggedUserUrl = `${this.myProfileUri}${'password'}`;
    return this.httpClient.put<MyProfile>(saveLoggedUserUrl, passwordData);

  }
  

  setForgotpasswordUrl(idToken: string): string {
    if (this.appConfig == undefined) 
      throw new Error(`[${MasterMyProfileService.name}]: Unexpected code path reached. 'appConfig' was not expected to be null or undefined.`)
    return this.appConfig?.authentication.issuer + 
      `${'connect/endsession?id_token_hint=' + 
      idToken + `&post_logout_redirect_uri=` + 
      this.appConfig?.authentication.forgotPasswordUrl}`;
  }
}
